import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { AuthRoutingModule } from "./auth-routing.module";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { TranslateModule } from "@ngx-translate/core";

import { LoginComponent } from "./login/login.component";
import { MaintenanceComponent } from "./maintenance/maintenance.component";
import { VerificationComponent } from "./verification/verification.component";
import { LockComponent } from "./lock/lock.component";
import { LoadingAppComponent } from "./loadingApp/loadingApp.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { RegistrationComponent } from "./registration/registration.component";
import { Error404Component } from "./error404/error404.component";

// import { FormBuilder, FormGroup } from '@angular/forms';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { ClockService } from '@services';
import { DirectiveModule } from '@directives/directives.module';
import { MaterialModules } from '@libraries/material/material.module';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModules,
        AuthRoutingModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        DirectiveModule

    ],
    exports: [],
    declarations: [
        LoginComponent,
        MaintenanceComponent,
        VerificationComponent,
        LockComponent,
        LoadingAppComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        RegistrationComponent,
        Error404Component
    ],
    providers: [
        { provide: 'ClockService', useClass: ClockService },
    ],
})
export class AuthModule { }
